<template>
  <div class="home" v-if="renderComponent">
    <Header />
      <div data-v-241e4969="" data-v-4f540693="" class="herohome">
        <div data-v-241e4969="" class="d-block d-md-none">
          <img data-v-241e4969="" src="https://api-site-mig.sotreq.com.br/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBbVFHIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--de136505d4a80bc368e1dcc8c14f877751cbef9d/heroFilial2mob.png" alt="HeroMercados" class="img-fluid">
          <div data-v-241e4969="" class="container my-2 my-md-0 d-flex align-items-center text-left h-100">
            <div data-v-241e4969="" class="text-black text-left">
              <h1 data-v-241e4969="" class="mt-3 mt-lg-0 font-weight-bold display-lg-4"> Filiais Sotreq  </h1>
              <div data-v-241e4969="" class="bar"></div>
              </div>
              </div>
              </div>
              <div data-v-241e4969="" class="d-none  d-md-block">
                <div data-v-241e4969="" class="hero-overlay">&nbsp;</div>
                <div data-v-241e4969="" class="hero-img active" style="background-image: url(https://api-site-mig.sotreq.com.br/rails/active_storage/blobs/eyJfcmFpbHMiOnsibWVzc2FnZSI6IkJBaHBBbU1HIiwiZXhwIjpudWxsLCJwdXIiOiJibG9iX2lkIn19--dd6a3ec6c24d0d5392d8bce9f531acb6a1da7907/heroFilial2.png);">
                <div data-v-241e4969="" class="container d-flex align-items-center text-left h-100 p-0">
                  <div data-v-241e4969="" class="col-7 text-white text-left">
                    <h1 data-v-241e4969="" class="display-4 font-weight-bold lh-sm"> Filiais Sotreq  </h1>
                    <div data-v-241e4969="" class="bar mt-1"></div>
                    <div data-v-241e4969=""></div>
                    </div>
                    </div>
                    </div>
                    </div>
                    </div>
    <div class="container">
      <div class="row my-5">
        <div class="col text-left">
          <h2 class="font-weight-bold">Encontre uma filial <br/> Sotreq Cat perto de você!</h2>
          <div class="bar mb-3 mb-lg-5"></div>
          <p class="preline">Com mais 80 anos de inovação, a Sotreq é uma empresa nacional que fornece tecnologia, maquinário, soluções e suporte ao produto altamente especializado para os segmentos de construção, mineração, energia, petróleo, marítimo, gás, florestal e agronegócio.</p>
        </div>
        <div class="col mapcontainer" >
          <div ref="mapContainer" class="map"></div>
        </div>
      </div>
    </div>
        <div class="w-100 bg-yellow">
      <div class="container my-5 my-md-0 text-left h-100 pt-3 pb-1">
        <h1 class="text-left text-lg-center font-weight-bold">
          Encontre a filial mais próxima
        </h1>
      </div>
    </div>
    <div class="w-100 bg-trasparent">
      <div class="container  text-left h-100 py-1 py-lg-3">
        <div class="row">
          <div class="col-12 col-xl-6 text-black text-left">
            <div class="row g-0 align-items-end">
              <div class="col-md-6">
                <label for="termo">Buscar filial</label>
                <input
                  v-model="termo"
                  id="termo"
                  class="form-control"
                  placeholder="Digite o nome da filial ou cidade..."
                />
              </div>
              <div class="col-md-4">
                <label for="contact[estado]">Filial por estado</label>
                <select
                  placeholder="Escolha..."
                  name="contact[estado]"
                  id="contact_estado"
                  class="form-control"
                  required=""
                  v-model="state"
                >
                  <option value="">Escolha...</option>
                  <option value="Acre">Acre</option>
                  <option value="Alagoas">Alagoas</option>
                  <option value="Amapá">Amapá</option>
                  <option value="Amazonas">Amazonas</option>
                  <option value="Bahia">Bahia</option>
                  <option value="Ceará">Ceará</option>
                  <option value="Distrito Federal">Distrito Federal</option>
                  <option value="Espírito Santo">Espírito Santo</option>
                  <option value="Goiás">Goiás</option>
                  <option value="Maranhão">Maranhão</option>
                  <option value="Mato Grosso">Mato Grosso</option>
                  <option value="Mato Grosso do Sul">Mato Grosso do Sul</option>
                  <option value="Minas Gerais">Minas Gerais</option>
                  <option value="Pará">Pará</option>
                  <option value="Paraíba">Paraíba</option>
                  <option value="Paraná">Paraná</option>
                  <option value="Pernambuco">Pernambuco</option>
                  <option value="Piauí">Piauí</option>
                  <option value="Rio de Janeiro">Rio de Janeiro</option>
                  <option value="Rio Grande do Norte">
                    Rio Grande do Norte
                  </option>
                  <option value="Rio Grande do Sul">Rio Grande do Sul</option>
                  <option value="Rondônia">Rondônia</option>
                  <option value="Roraima">Roraima</option>
                  <option value="Santa Catarina">Santa Catarina</option>
                  <option value="São Paulo">São Paulo</option>
                  <option value="Sergipe">Sergipe</option>
                  <option value="Tocantins">Tocantins</option>
                </select>
              </div>
              <div class="col-md-2">
                <button
                  class="btn btn-warning"
                  type="button"
                  @click="makeMySearch"
                >
                  Buscar
                </button>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-6 input-group my-3"></div>
        </div>
      </div>
    </div>
      <div class="container pt-4">
      <div
        id="listings"
        class="listings row row-cols-1 row-cols-md-2 row-cols-xl-4 g-1 px-3 px-lg-0"
      >
        <div v-for="filial in filiais" :key="filial.properties.id" class="col mb-4" :data-filial-id="filial.properties.id">
          <div class="card h-100 border border-dark rounded-0">
            <div class="card-body px-2 pt-3">
              <a :href="'/#/filial/' + filial.properties.id" class="card-link notalink" @click.prevent="centerMapOnFilial(filial)">
                <h4 class="text-yellow mb-0 font-weight-bold">{{ filial.properties.state || 'Estado não informado' }}</h4>
                <h4 class="text-black mb-3 font-weight-bold">{{ filial.properties.nome || filial.properties.name || 'Nome não informado' }}</h4>
              </a>
              <p class="card-text">
                <span v-if="filial.properties.address">
                  {{ filial.properties.address }}<span v-if="filial.properties.zip">, CEP: {{ filial.properties.zip }}</span><br />
                  <span v-if="filial.properties.city">{{ filial.properties.city }}<span v-if="filial.properties.state"> - {{ filial.properties.state }}</span><br /></span>
                  <span v-if="filial.properties.phone"><i class="bi bi-telephone-fill"></i> {{ filial.properties.phone }}</span>
                </span>
                <span v-else class="text-muted">Informações de endereço não disponíveis</span>
              </p>
            </div>
            <div class="card-footer bg-transparent border-0 p-1 mt-1">
              <a :href="'/#/filial/' + filial.properties.id" class="w-100 btn btn-yellow-card">
                <span class="text-center text-black"><i class="bi bi-arrow-right-circle"></i> Mais detalhes</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>
<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Novidade from "@/components/Novidade.vue";
import ApiContent from "@/services/api.js";

export default {
  name: "Filiais",
  async mounted() {
    window.scrollTo(0, 0);
    this.loadGoogleMapsAPI();
  },
  components: {
    Header,
    Footer,
    Novidade,
  },
  data() {
    return {
      renderComponent: true,
      termo: '',
      state: '',
      map: null,
      filiais: [],
      currentInfoWindow: null,
    };
  },
  methods: {
    loadGoogleMapsAPI() {
      if (window.google && window.google.maps) {
        this.loadCategoria();
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBq6z4_bOk9eq27Ut9nxraS2Eit1U2L81o&libraries=places';
      script.onload = () => {
        this.loadCategoria();
      };
      script.onerror = () => {
        console.error('Failed to load Google Maps API');
      };
      document.head.appendChild(script);
    },
    async loadCategoria() {
      var searchTerm = this.termo || this.state;
      const resp = await ApiContent.get(`geofiliais?commit=Search&q[nome_or_cidade_or_estado_or_endereco_or_servicos_name_cont]=${searchTerm ?? ''}&q[s]=estado+asc`);
      const geojson = resp.data.filiais;
      console.log('API Response:', resp.data);
      console.log('Filiais data:', geojson);
      this.filiais = geojson;
      
      // Remove previous map if exists
      if (this.map) {
        this.map = null;
        // Clear map container
        if (this.$refs.mapContainer) {
          this.$refs.mapContainer.innerHTML = '';
        }
      }
      
      // Calculate map center from features if available
      let center = { lat: -17.468, lng: -55.822 }; // Google Maps uses {lat, lng} format
      if (geojson.length > 0) {
        const valid = geojson.filter(f => {
          if (!f.geometry || !f.geometry.coordinates || f.geometry.coordinates.length !== 2) return false;
          const lng = parseFloat(String(f.geometry.coordinates[0]).trim());
          const lat = parseFloat(String(f.geometry.coordinates[1]).trim());
          return !isNaN(lng) && !isNaN(lat) && lng !== 0 && lat !== 0;
        });
        
        if (valid.length > 0) {
          const avgLng = valid.reduce((sum, f) => sum + parseFloat(String(f.geometry.coordinates[0]).trim()), 0) / valid.length;
          const avgLat = valid.reduce((sum, f) => sum + parseFloat(String(f.geometry.coordinates[1]).trim()), 0) / valid.length;
          center = { lat: avgLat, lng: avgLng };
        }
      }
      
      // Create Google Map
      try {
        if (!window.google || !window.google.maps) {
          console.error('Google Maps API not loaded');
          return;
        }

        this.map = new window.google.maps.Map(this.$refs.mapContainer, {
          center: center,
          zoom: 4,
          mapTypeId: window.google.maps.MapTypeId.ROADMAP,
          mapTypeControl: false,
          streetViewControl: false,
          fullscreenControl: false,
          zoomControl: true
        });
        
        console.log('Google Map created successfully');
        
      } catch (error) {
        console.error('Error creating Google Map:', error);
        return;
      }
      
      // Add markers for each filial
      geojson.forEach((feature, index) => {
        console.log(`Processing filial ${index}:`, feature);
        
        // Check if feature has proper geometry and coordinates
        if (feature.geometry && feature.geometry.coordinates && 
            feature.geometry.coordinates.length === 2) {
          
          // Clean up coordinates (remove spaces and convert to numbers)
          const lngStr = String(feature.geometry.coordinates[0]).trim();
          const latStr = String(feature.geometry.coordinates[1]).trim();
          const lng = parseFloat(lngStr);
          const lat = parseFloat(latStr);
          
          // Validate coordinates are valid numbers
          if (!isNaN(lng) && !isNaN(lat) && lng !== 0 && lat !== 0) {
            const props = feature.properties;
            
            // Create marker
            const marker = new window.google.maps.Marker({
              position: { lat: lat, lng: lng },
              map: this.map,
              title: props.nome || props.name || 'Filial',
              icon: {
                url: 'pin.png',
                scaledSize: new window.google.maps.Size(33, 44),
                anchor: new window.google.maps.Point(16.5, 44)
              }
            });
            
            // Create info window content
            const infoWindowContent = `
              <div class='card' style='border: none; max-width: 250px;'>
                <h5 class='card-header' style='background-color: #ffcb11; color: #000; margin: 0; padding: 10px;'>
                  ${props.city || ''}
                </h5>
                <div class='card-body' style='padding: 10px;'>
                  <p class='card-text' style='margin: 0; font-size: 14px;'>
                    ${props.city || ''} - ${props.state || ''}<br>
                    ${props.address || ''}<br>
                    CEP: ${props.zip || ''}<br>
                    Tel: ${props.phone || ''}
                  </p>
                </div>
              </div>
            `;
            
            const infoWindow = new window.google.maps.InfoWindow({
              content: infoWindowContent
            });
            
            // Marker click interaction
            marker.addListener('click', () => {
              // Close any open info windows
              if (this.currentInfoWindow) {
                this.currentInfoWindow.close();
              }
              
              // Open new info window
              infoWindow.open(this.map, marker);
              this.currentInfoWindow = infoWindow;
              
              // Center the map on the selected marker
              this.map.panTo({ lat: lat, lng: lng });
              
              // Find and highlight the corresponding card
              this.$nextTick(() => {
                const cards = document.querySelectorAll('.listings .col');
                cards.forEach(card => card.classList.remove('active'));
                
                // Find the card with matching filial id
                const targetCard = document.querySelector(`[data-filial-id="${props.id}"]`);
                if (targetCard) {
                  targetCard.classList.add('active');
                  targetCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
              });
            });
            
          } else {
            console.log('Skipping filial due to invalid coordinates:', { lng, lat, feature });
          }
        } else {
          console.log('Skipping filial due to missing geometry:', feature);
        }
      });
    },
    forceRerender() {
      this.renderComponent = false;
      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    makeMySearch() {
      this.loadCategoria();
      this.forceRerender();
    },
    centerMapOnFilial(filial) {
      if (this.map && filial.geometry && filial.geometry.coordinates && filial.geometry.coordinates.length === 2) {
        const lng = parseFloat(String(filial.geometry.coordinates[0]).trim());
        const lat = parseFloat(String(filial.geometry.coordinates[1]).trim());
        
        if (!isNaN(lng) && !isNaN(lat) && lng !== 0 && lat !== 0) {
          this.map.panTo({ lat: lat, lng: lng });
          this.map.setZoom(12);
          
          // Highlight the card
          this.$nextTick(() => {
            const cards = document.querySelectorAll('.listings .col');
            cards.forEach(card => card.classList.remove('active'));
            
            const targetCard = document.querySelector(`[data-filial-id="${filial.properties.id}"]`);
            if (targetCard) {
              targetCard.classList.add('active');
            }
          });
        }
      }
    },
  },
  unmounted() {
    if (this.currentInfoWindow) {
      this.currentInfoWindow.close();
      this.currentInfoWindow = null;
    }
    if (this.map) {
      this.map = null;
    }
  },
};
</script>
<style scoped>

.col.active {
  transform: scale(1.02);
  transition: transform 0.2s ease;
}

.col.active .card {
  box-shadow: 0 4px 8px rgba(255, 203, 17, 0.3);
  border-color: #ffcb11 !important;
}

.quadrado {
  border: 5px solid #ffcb11;
}

.equipamento_nvo {
  background: rgb(2, 0, 36);
  background: radial-gradient(
    circle,
    rgba(2, 0, 36, 1) 0%,
    rgba(214, 155, 31, 1) 50%
  );
}

a {
  text-decoration: none;
}

button {
  border-radius: 0;
  border: 3px solid white;
  background-color: rgba(0, 0, 0, 0.4);
  color: white;
}

button:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

.bar {
  height: 5px;
  background-color: #ffcb11;
  width: 100px;
}

.traco {
  width: 100px;
  background-color: #ffcb11;
}

.traco.active {
  width: 100px;
  height: 10px;
}

.hero-img {
  max-height: 70vh;
  height: 700px;
  width: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

/* Place text in the middle of the image */
.hero-text {
  text-align: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}



.yellowbar {
  width: 100%;
  height: 12px;
  background-color: #ffcd11;
}

.greybar {
  width: 100%;
  height: 131px;
  background-color: #ececec;
}

.greybar {
  width: 100%;
  height: 100%;
  background-color: #ececec;
}

.black-bg {
  background-color: #000;
}

.separatorbox {
  min-height: 100%;
  border-right: solid 1px #000;
  margin: 0px 1em 0px 1em;
}

.plus-drop {
  width: 1.5em;
}

.spec-collapse {
  border-top: solid 0.5px #000;
}

.last-line {
  min-width: 100%;
  border-top: solid 1px #000;
}

a.w-100[aria-expanded="false"]
  div.d-flex.justify-content-between.spec-collapse.p-3
  img.plus-drop {
  transform: rotate(0deg);
  transition: transform 1s;
}

a.w-100[aria-expanded="true"]
  div.d-flex.justify-content-between.spec-collapse.p-3
  img.plus-drop {
  transform: rotate(45deg);
  transition: transform 1s;
}

.position-absolute.w-100.h-100.preloader {
  background-color: #fff;
  z-index: 99999;
  position: absolute;
  margin: auto;
  padding-top: 35vh;
}

.sidebar {
  position: relative;
  width: 33.3333%;
  height: 100%;
  overflow: hidden;
  border-right: 1px solid rgba(0, 0, 0, 0.25);
}

.pad2 {
  padding: 20px;
}

.quiet {
  color: #888;
}

.map {
  position: relative;
  width: 358px;
  min-width: 358px;
  max-width: 358px;
  height: 285px;
  min-height: 285px;
  max-height: 285px;
}

/* Google Maps specific fixes */
.map * {
  box-sizing: content-box;
}

.map img {
  max-width: none !important;
  max-height: none !important;
}

.map .gm-style {
  font: 400 11px Roboto, Arial, sans-serif;
}

.map .gm-style img {
  max-width: none;
}

.map .gm-style label {
  width: auto;
  display: inline;
}

.heading {
  background: #fff;
  border-bottom: 1px solid #eee;
  min-height: 60px;
  line-height: 60px;
  padding: 0 10px;
}

::-webkit-scrollbar {
  width: 3px;
  height: 3px;
  border-left: 0;
  background: rgba(0, 0, 0, 0.1);
}

::-webkit-scrollbar-track {
  background: none;
}

::-webkit-scrollbar-thumb {
  background: #00853e;
  border-radius: 0;
}

.clearfix {
  display: block;
}

.clearfix:after {
  content: ".";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

/* Marker tweaks */
.leaflet-popup-close-button {
  display: none;
}

.leaflet-popup-content {
  font: 400 15px/22px "Source Sans Pro", "Helvetica Neue", Sans-serif;
  padding: 0;
  width: 200px;
}

.leaflet-popup-content-wrapper {
  padding: 0;
}

.leaflet-popup-content h3 {
  background: yellow;
  color: #000;
  margin: 0;
  display: block;
  padding: 10px;
  border-radius: 3px 3px 0 0;
  font-weight: 700;
  margin-top: -15px;
}

.leaflet-popup-content div {
  padding: 10px;
}

.leaflet-container .leaflet-marker-icon {
  cursor: pointer;
}

a {
  text-decoration: none;
  color: black;
}

button {
  border: 2px solid white;
  background-color: black;
  color: white;
}

button:hover {
  border: 2px solid black;
  background-color: white;
  color: black;
}

.btnsend {
  text-transform: uppercase;
  background-color: #f7b220;
  border: #f7b220;
  color: black;
  border-radius: 0.2em;
}

.btnsend:hover {
  color: #f7b220;
  background-color: #000;
}

@media (min-width: 768px) {
  .map {
    width: 100%;
    min-width: 100%;
    max-width: 379px;
  }
  
  .map * {
    box-sizing: content-box;
  }
  
  .map img {
    max-width: none !important;
    max-height: none !important;
  }
  
  .herohome {
    margin-top: -101px;
  }
}
@media (min-width: 1280px) {
  .map {
    position: relative;
    width: 668px;
    min-width: 668px;
    max-width: 668px;
    height: 354px;
    min-height: 354px;
    max-height: 354px;
  }
  
  .map * {
    box-sizing: content-box;
  }
  
  .map img {
    max-width: none !important;
    max-height: none !important;
  }
}
@media (max-width: 578px) {
  button.btn.btn-warning {
    width: 100%;
    margin-top: 16px;
}
}

</style>
